import classNames from "classnames";
import { GetInputPropsOptions } from "downshift";
import React from "react";
import agentInputStyles from "@fidget/common/components/form/agentInput.css";
import styles from "./searchingInput.css";

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, "onChange"> {
  onChange: (v: string) => void;
  withIcon?: boolean;
  inputProps?: GetInputPropsOptions;
}

export const SearchingInput = ({
  onChange,
  withIcon = true,
  inputProps,
  children,
  ...rest
}: React.PropsWithChildren<Props>) => (
  <div className={agentInputStyles["input-wrap"]}>
    {withIcon && <i className={classNames("icon-search", styles["search-icon"])} />}
    <input
      {...inputProps}
      {...rest}
      onChange={(ev) => {
        onChange(ev.target.value);

        if (inputProps && inputProps.onChange) {
          inputProps.onChange(ev);
        }
      }}
    />
    {children}
  </div>
);

export const IconClear = (props: React.HTMLProps<HTMLDivElement>) => (
  <i {...props} className={classNames("icon-close-cross", styles["clear-icon"])} />
);
